<div class="driver-check-in-support__help-icon">
    <i class="fa fa-lg fa-question-circle" (click)="goToDriverCheckInSupportPage()"></i>
</div>